import {useBackendPolling} from '../../redux/app/hooks/useBackendPolling';

export const BackendPolling = () => {
  useBackendPolling();
  return null;
};
